import type * as Types from 'app/types/graphql';

import { useMutation, type UseMutationOptions } from '@tanstack/react-query';
import { appFetcher } from '~/api/utils/gatewayClient';
export type ShopMetaCreateOrUpdateMutationVariables = Types.Exact<{
  input: Types.UpsertShopMetaInput;
}>;

export type ShopMetaCreateOrUpdateMutationResponse = {
  shopMetaCreateOrUpdate?: Types.Maybe<
    Pick<Types.ShopMeta, 'createdAt' | 'id' | 'key' | 'updatedAt' | 'value'>
  >;
};

export const ShopMetaCreateOrUpdateDocument = `
    mutation ShopMetaCreateOrUpdate($input: UpsertShopMetaInput!) {
  shopMetaCreateOrUpdate(input: $input) {
    createdAt
    id
    key
    updatedAt
    value
  }
}
    `;

export const useShopMetaCreateOrUpdateMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<
    ShopMetaCreateOrUpdateMutationResponse,
    TError,
    ShopMetaCreateOrUpdateMutationVariables,
    TContext
  >,
) => {
  return useMutation<
    ShopMetaCreateOrUpdateMutationResponse,
    TError,
    ShopMetaCreateOrUpdateMutationVariables,
    TContext
  >(
    ['ShopMetaCreateOrUpdate'],
    (variables?: ShopMetaCreateOrUpdateMutationVariables) =>
      appFetcher<ShopMetaCreateOrUpdateMutationResponse, ShopMetaCreateOrUpdateMutationVariables>(
        ShopMetaCreateOrUpdateDocument,
        variables,
      )(),
    options,
  );
};

useShopMetaCreateOrUpdateMutation.getKey = () => ['ShopMetaCreateOrUpdate'];
